/** @format */
import Master from '../Layouts/Master';
import DefaultImg from '../../Assets/Images/default.png';
import { formatSidLabel } from '../../Shared/utils/helper';
import { useParams } from 'react-router';
import { useContext, useState, useEffect } from 'react';
import { EventContext } from '../../Contexts/EventContext';
import useApi from '../../Shared/hooks/api/Index';
import { error } from '../../Shared/Components/Toast';
import Loading from '../../Shared/Components/Loading';

const Show = () => {
	const { eventId, userId } = useParams();
	const eventContext = useContext(EventContext);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		getUser();
	}, [eventId, userId]);

	const getUser = async () => {
		setLoading(true);
		await useApi.get(
			`/id-card/event/${eventId}/user/${userId}`,
			{},
			(res) => {
				let data = res.data.data;
				if (data?.success == false) {
					setLoading(false);
					return error(data?.message);
				}
				eventContext.user = data;
				setLoading(false);
			},
			(err) => {
				setLoading(false);
				error('هنگام دریافت اطلاعات خطایی رخ داده است.');
			},
		);
	};
	return loading ? (
		<Loading />
	) : (
		<Master
			showSidebar={false}
			containerFullWidth={true}
			headerFixed={true}
			title='نمایش اطلاعات '>
			<div className='w-100 bg-dark-mode-3 d-flex flex-column vh-100'>
				<div className='d-flex flex-row border-top pt-2 bg-purple justify-content-between'>
					<div className='d-flex flex-row'>
						<i className='fad fa-calendar-check f-20 mx-2 text-dark-mode'></i>
						<h1 className='f-13 font-weight-bold text-dark-mode mt-1'>
							نمایش اطلاعات
						</h1>
					</div>
				</div>
				<div className='row mx-2 overflow-auto'>
					<div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
						<div className='form-group w-100 my-2 d-flex justify-content-center'>
							<label className='my-2 text-dark-mode'>عکس پرسنلی</label>
							<img
								className='img-thumbnail'
								src={eventContext.user?.avatar ?? DefaultImg}
								style={{ width: '120px', height: '120px' }}
								alt=''
							/>
						</div>
					</div>
					<div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
						<div className='form-group w-100 my-2 d-flex justify-content-center'>
							<label className='my-2 text-dark-mode'>
								نامه تایید مدیریت سازمان{' '}
							</label>
							<img
								className='img-thumbnail'
								src={eventContext.user?.organization_letter ?? DefaultImg}
								style={{ width: '120px', height: '120px' }}
								alt=''
							/>
						</div>
					</div>
					<div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
						<div className='form-group w-100 my-2 d-flex justify-content-center'>
							<label className='my-2 text-dark-mode'>حکم کارگزینی</label>
							<img
								className='img-thumbnail'
								src={eventContext.user?.recruitment_order ?? DefaultImg}
								style={{ width: '120px', height: '120px' }}
								alt=''
							/>
						</div>
					</div>
					<div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
						<div className='form-group'>
							<label className='my-2 text-dark-mode'>نام</label>
							<input
								type='text'
								disabled
								className='form-control'
								value={eventContext.user?.first_name}
							/>
						</div>
					</div>
					<div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
						<div className='form-group'>
							<label className='my-2 text-dark-mode'>نام خانوادگی</label>
							<input
								type='text'
								disabled
								className='form-control'
								value={eventContext.user?.last_name}
							/>
						</div>
					</div>
					<div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
						<div className='form-group'>
							<label className='my-2 text-dark-mode'>کد ملی</label>
							<input
								type='text'
								disabled
								className='form-control'
								value={eventContext.user?.nat_code}
							/>
						</div>
					</div>
					<div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
						<div className='form-group'>
							<label className='my-2 text-dark-mode'>نام سازمان</label>
							<input
								type='text'
								disabled
								className='form-control'
								value={eventContext.user?.organization}
							/>
						</div>
					</div>
					<div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
						<div className='form-group'>
							<label className='my-2 text-dark-mode'>موبایل</label>
							<input
								type='text'
								disabled
								className='form-control'
								value={eventContext.user?.mobile}
							/>
						</div>
					</div>
					<div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
						<div className='form-group'>
							<label className='my-2 text-dark-mode'>استان</label>
							<input
								type='text'
								disabled
								className='form-control'
								value={eventContext.user?.province_name}
							/>
						</div>
					</div>
					<div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
						<div className='form-group'>
							<label className='my-2 text-dark-mode'>سمت</label>
							<input
								type='text'
								disabled
								className='form-control'
								value={formatSidLabel(eventContext.user)}
							/>
						</div>
					</div>
				</div>
			</div>
		</Master>
	);
};

export default Show;
